import { Box, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function SeccionExtra() {
  const { t } = useTranslation();

  const handleScrollToForm = () => {
    const element = document.getElementById("formulario-postulacion");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        py: { xs: 10, md: 15 },
        bgcolor: "#f8fafc",
        overflow: "visible",
         
      }}
    >

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={{ xs: 6, md: 10, lg: 12 }} sx={{ alignItems: "center" }}>
          
          {/* Lado Izquierdo: Contenido Textual */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              component={motion.div}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 700,
                  color: "#0A1128",
                  lineHeight: 1.2,
                  mb: 3,
                  letterSpacing: "-0.02em",
                  fontSize: { xs: "2.25rem", sm: "3rem", lg: "3.5rem" },
                   
                }}
              >
                {t("postulate.seccion_extra.title1")}{" "}
                <Box component="span" sx={{ color: "#68a8de" }}>
                  {t("postulate.seccion_extra.title2")}
                </Box>
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.125rem",
                  color: "#475569",
                  lineHeight: 1.75,
                  maxWidth: 500,
                  mb: 5,
                   
                }}
              >
                {t("postulate.seccion_extra.description")}
              </Typography>

              {/* Badge interactivo */}
              <Box
                onClick={handleScrollToForm}
                sx={{
                  display: "inline-block",
                  bgcolor: "white",
                  color: "#0A1128",
                  fontWeight: 700,
                  fontSize: { xs: "0.95rem", md: "1.1rem" },
                  py: 1.8,
                  px: 4,
                  borderRadius: "50px",
                  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
                  border: "2px solid #68a8de",
                  cursor: "pointer",
                  userSelect: "none",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    bgcolor: "#68a8de",
                    color: "white",
                    transform: "translateY(-2px)",
                    boxShadow: "0 10px 15px -3px rgba(104, 168, 222, 0.3)",
                  },
                  "&:active": {
                    transform: "translateY(0px)",
                  }
                }}
              >
                {t("postulate.seccion_extra.button")}
              </Box>
            </Box>
          </Grid>

          {/* Lado Derecho: Imagen y Efectos de Fondo Animados */}
          <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              component={motion.div}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              sx={{ position: "relative" }}
            >
              {/* Brillo desenfocado (Pulse) */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  bgcolor: "rgba(104, 168, 222, 0.2)",
                  borderRadius: "50%",
                  filter: "blur(24px)",
                  transform: "scale(1.1)",
                  animation: "pulse v9-pulse 3s infinite ease-in-out",
                  "@keyframes v9-pulse": {
                    "0%, 100%": { opacity: 0.3 },
                    "50%": { opacity: 0.6 },
                  },
                }}
              />
              
              {/* Anillo de guiones (Spin) */}
              <Box
                sx={{
                  position: "absolute",
                  inset: "-16px",
                  border: "2px dashed rgba(104, 168, 222, 0.4)",
                  borderRadius: "50%",
                  animation: "spin v9-spin 25s linear infinite",
                  "@keyframes v9-spin": {
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />

              {/* Contenedor circular de la imagen */}
              <Box
                sx={{
                  position: "relative",
                  width: { xs: 260, sm: 320, lg: 384 },
                  height: { xs: 260, sm: 320, lg: 384 },
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "8px solid #ffffff",
                  boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)",
                }}
              >
                <Box
                  component="img"
                  src="./postulate.webp"
                  alt="Equipo colaborando"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}